import { useEffect, useMemo, useState } from 'react';
import * as React from 'react';
import { Button, Form, message, Row, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router';
import ContractUserType from '@/components/organisms/contract/ContractUserType';
import { UploadFile } from 'antd/es/upload/interface';
import { UploadChangeParam } from 'antd/lib/upload';
import { Store } from 'antd/lib/form/interface';
import ContractWriteTemplate from '@/components/template/contract/ContractWriteTemplate';
import ContractUserForm from '@/components/organisms/contract/ContractUserForm';
import ContractInformationForm from '@/components/organisms/contract/ContractInformationForm';
import { progress } from '@/utils/fileExtension';
import ContractInsuranceForm from '@/components/organisms/contract/ContractInsuranceForm';
import { API_CONTRACT, API_CONTRACT_UPLOAD, PATH_CONTRACT } from '@/constants/constant';
import api from '@/api';
import { ErrorMessage } from '@/constants/message';
import moment from 'moment';
import { pcontract } from '@/proto/proto';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';

const ContractWritePage = () => {
  const history = useHistory();
  const { current: company } = useSelector((state: RootState) => state.company);
  const [error, setError] = useState<any>();
  const [files, setFiles] = useState<UploadFile[]>([]);
  const [userTypes, setUserTypes] = useState<ContractUserType[]>([ContractUserType.CONTRACTOR, ContractUserType.PRIMARY]);

  const [isEqualSelected, setEqualSelected] = useState(false);

  const onClickConfirm = (values: Store) => {
    const { information, insurance, contractor, primary, secondary } = values;
    const { totalAmount, paidAmount, unpaidAmount, endAt, duration, ...info } = information;
    const [startAt, dueAt] = duration;
    if (isEqualSelected) {
      primary.name = contractor.name;
      primary.contract = contractor.contract;
      primary.registrationNo = contractor.registrationNo;
      primary.addr1 = contractor.addr1;
      primary.addr2 = contractor.addr2;
      primary.postcode = contractor.postcode;
    }
    api
      .post(API_CONTRACT, 'pcontract.PbContractCreateRequest', {
        contract: [
          {
            ...info,
            ...insurance,
            user: [contractor, primary, secondary].filterNotNull(),
            totalAmount: Number(`${totalAmount ?? 0}`.replace(',', '')),
            paidAmount: Number(`${paidAmount ?? 0}`.replace(',', '')),
            unpaidAmount: Number(`${unpaidAmount ?? 0}`.replace(',', '')),
            startAt: startAt?.format(),
            dueAt: dueAt?.format(),
            endAt: endAt?.format(),
            companyId: company.base.id,
            contractAt: moment().format(),
          },
        ],
      })
      .then(async ({ data }) => {
        const target = files.map((file) => file.originFileObj).filter((file): file is File | Blob => file !== undefined);
        if (target.length > 0) {
          const { contract } = data;
          const form = new FormData();
          target.map((file) => form.append('files', file));
          contract.map(({ base }: pcontract.IPbContract) => form.append('contractIdList', `${base?.id}`));
          await api.upload(API_CONTRACT_UPLOAD, form);
        }
      })
      .then(() => history.replace(PATH_CONTRACT))
      .catch((e) => {
        setError(e?.response?.data?.message ?? ErrorMessage.network.disconnected);
      });
  };

  const userForm: React.ReactNode = useMemo(() => {
    return userTypes.map((type) => (
      <ContractUserForm
        userType={type}
        onChangeEqual={(checked) => setEqualSelected(checked)}
        isEqualChecked={isEqualSelected}
        extra={
          !userTypes.includes(ContractUserType.SECONDARY) && [
            <Button onClick={() => setUserTypes([...userTypes, ContractUserType.SECONDARY])}>추가</Button>,
          ]
        }
      />
    ));
  }, [isEqualSelected, userTypes]);

  useEffect(() => {
    if (error) {
      message.error(error);
      setError(null);
    }
  }, [error]);

  return (
    <ContractWriteTemplate
      extra={[
        <Upload
          fileList={files}
          accept=".jpg, .jpeg, .png, .pdf"
          customRequest={(option) => {
            progress((percentage) => {
              // option.onProgress({ percent: percentage }, option.file);
            }).then(() => {
              // option.onSuccess({ status: 'done' }, option.file);
            });
          }}
          onChange={({ fileList }: UploadChangeParam<UploadFile>) => {
            setFiles(fileList.filter((image) => image.size > 0).slice(-1));
          }}
        >
          <Button>
            <UploadOutlined /> 계약서 업로드
          </Button>
        </Upload>,
      ]}
    >
      <Form onFinish={onClickConfirm}>
        <Row gutter={[16, 16]}>
          <ContractInformationForm />
          {userForm}
          <ContractInsuranceForm />
        </Row>
        <Form.Item>
          <Button htmlType="submit" type="primary" style={{ float: 'right' }}>
            저장
          </Button>
        </Form.Item>
      </Form>
    </ContractWriteTemplate>
  );
};

export default ContractWritePage;
